import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { API } from 'aws-amplify'
import color from '../shared/color'
import StoryTitle from '../components/StoryTitle'
import { DonutChart } from '../d3'
import { Typography, Divider, Grid, CircularProgress, Paper} from '@material-ui/core'
import '../story.css'


function ES161RiskAssessment() {
    const [isLoading, setIsLoading] = useState(true)
    const [title] = useState("ES 161 and CIISafe v9 Risk Assessment")
    const [summary] = useState("The Status of Issues in MedES 1.6.1 & CIISafe v9 Risk Assessments.")
    const [categories] = useState(["security"])
    const [data, setData] = useState({})
    let history = useHistory()

    useEffect(() => {
        async function fetch() {
            //Read the data
            await API.get('qs-web-api', '/data/161RA/data.json', {})
                .then((storyData) => {
                    setData(storyData)
                })
                .catch(function (error) {
                    setData({date: "No Data Found"})
                    console.log(error)
                })
            setIsLoading(false)
        }
        fetch()
    }, [])
    if (isLoading) {
        return (<div className="circular-progress"><CircularProgress disableShrink /></div>)
    } else {
        return (
            <div id="story">
                <StoryTitle title={title} date={data.date} categories={categories}></StoryTitle>

                <Paper className="storySection">
                <Grid container justify="center" spacing={2} alignItems="stretch">
                    <div className="subText">
                        <Typography>
                            The status of different issues in MMS Product Security are tracked in JIRA. This article
                            uses the JIRA dashboard to showcase the status of the issues. The epics "MedES 1.6.1 Risk
                            Assessment" and "CIISafe Risk Assessment" have multiple issue categories such as Open DSC, Manual Items, Document Items,
                            Ready for Review and Ready for Test.
                            <p> </p><p> </p>
                            <b>Open DSC</b> - Items that can be mitigated through automation once tested with the product
                            <p> </p>
                            <b>Manual Items</b> - Items requiring analysis for automation or mitigation
                            <p> </p>
                            <b>Document Items</b> - Items that can be closed through providing appropriate documentation
                            <p> </p>
                            <b>Ready for Test</b> - Items ready for testing to validate product functionality
                            <p> </p>
                            <b>Ready for Review</b> - Items ready for review by Ausgar
                            <p> </p>
                            <b>Definition of Done</b>: A status of an issue is marked done when the issue is resolved and moved
                            to the completed section in JIRA.
                        </Typography>
                    </div>
                </Grid>
                </Paper>

                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                Status of all findings
                            </Typography>
                        </div>
                    </Grid>

                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <DonutChart data={data.all} colors={color.defaultScheme} tooltip={"The value of<br>this cell is: "} width={600} height={400} radius={200}></DonutChart>
                    </Grid>
                </Paper>

                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                CAT I Status
                            </Typography>
                        </div>
                    </Grid>

                   <Grid container justify="center" spacing={2} alignItems="stretch">
                        <DonutChart data={data.catI} colors={color.defaultScheme} tooltip={"The value of<br>this cell is: "} width={600} height={400} radius={200}></DonutChart>
                    </Grid>
                </Paper>

                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                CAT II Status
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <DonutChart data={data.catII} colors={color.defaultScheme} tooltip={"The value of<br>this cell is: "} width={600} height={400} radius={200}></DonutChart>
                    </Grid>
                </Paper>

            </div>
        )
    }
}
export default ES161RiskAssessment
